import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1662f2dd&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1662f2dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1662f2dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1662f2dd')) {
      api.createRecord('1662f2dd', component.options)
    } else {
      api.reload('1662f2dd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1662f2dd&scoped=true&", function () {
      api.rerender('1662f2dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/player/index.vue"
export default component.exports